import React, { useState } from 'react';
import { UiComponent } from 'components';
import { AdminsQuery } from 'queries';
import { IAdmin } from 'types';
import useModal from 'hooks/useModal';
import { theme } from 'styles';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import RoleSelect from '../RoleSelect';

interface Props {
  admin: IAdmin;
}

// 계정의 역할을 선택한 역할 하나로 교체
function RoleChange({ admin }: Props) {
  const { handleClose, handleAlert } = useModal();
  const { mutateAsync: updateRoles, isPending } = AdminsQuery.useUpdateRoles();
  const [roleId, setRoleId] = useState('');
  const current = admin.roles ?? [];

  const handleSubmit = async () => {
    if (!roleId) {
      handleAlert('변경할 권한을 선택해주세요');
      return;
    }
    try {
      await updateRoles({ id: admin.id, roleIds: [Number(roleId)] });
      toast.success('역할이 변경되었습니다');
      handleClose();
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <div css={{ width: 400, '> p': { margin: '16px 0 8px', fontWeight: 600 } }}>
      <p>현재 역할</p>
      <div css={{ fontSize: 14, color: theme.color.textSub }}>
        {current.length === 0
          ? '-'
          : current
              .map((r) => `${r.name} (${r.organization?.displayName ?? ''})`)
              .join(', ')}
      </div>
      <p>변경할 역할</p>
      <RoleSelect roleId={roleId} onChange={setRoleId} />
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isPending}
        >
          변경하기
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default RoleChange;
